<template>
  <div class="columns is-centered">
    <div class="column is-full-mobile is-three-quarters-desktop ">
      <div class="box is-light">
        <div class="columns is-centered">
          <div class="column is-12-mobile is-8-tablet is-one-half-widescreen">
            <div
              class="columns is-mobile head1 is-gant"
              style=" border-radius: 5px;"
            >
              <div class="column" style="text-align: center;">
                <h1 class="title is-4" style="color: white;">
                  <b-icon icon="briefcase"> </b-icon> Your Planned Trips
                </h1>
              </div>
            </div>
            <div>
              <div v-if="pageLoading">
                <b-loading
                  :is-full-page="false"
                  :active="pageLoading"
                  :can-cancel="true"
                ></b-loading>
              </div>

              <div v-else-if="trips.length > 0">
                <div v-if="detailsLoading" class="notification is-warning">
                  Loading {{ this.tripsLoaded.length }} of
                  {{ this.trips.length }} trips...
                </div>

                <div class="p-4">
                  <h3 class="is-size-4 mb-2 has-text-centered">
                    <span v-if="trips.length == 1">
                      {{ this.tripsLoaded.length }} Trip Found
                    </span>
                    <span v-else-if="trips.length > 1">
                      {{ this.tripsLoaded.length }} Trips Found
                    </span>
                  </h3>

                  <div class="has-text-centered mb-4 is-size-7">
                    <router-link :to="{ name: 'past-trips' }">
                      View completed or cancelled trips</router-link
                    >
                  </div>
                </div>

                <div
                  v-if="!detailsLoading && this.tripsNotLoaded.length > 0"
                  class="notification is-danger is-light"
                  @click="fetchTripDetails()"
                  style="cursor:pointer"
                >
                  {{ this.tripsNotLoaded.length }} trips failed to load. Click
                  here to retry.
                </div>

                <div v-if="activeTrips.length">
                  <hr />
                  <div class="trips-list">
                    <div v-for="(trip, index) in activeTrips" :key="index">
                      <TripCard :trip="trip"></TripCard>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="noTripsFound">
                <div class="is-size-5"> You have no planned trips! </div>
                <div class="has-text-centered mb-4 is-size-7">
                  <router-link :to="{ name: 'past-trips' }">
                    View completed or cancelled trips</router-link
                  >
                </div>
              </div>
            </div>
          </div>

          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import TripModal from "../components/Trip/TripModal.vue";
import TripCard from "../components/Trip/TripCard.vue";
export default {
  name: "TripPage",
  components: {
    TripCard,
  },
  data: function() {
    return {
      trips: [],
      pageLoading: true,
      tripKey: 1,
      noTripsFound: false,
      loadStatus: [],
    };
  },
  computed: {
    /*
    solution() {
      return this.$store.state.result;
    },
    disable() {
      return (
        Object.keys(this.solution.car).length === 0 &&
        Object.keys(this.solution.hotel).length === 0 &&
        Object.keys(this.solution.flight).length === 0
      );
    },
    tripsList() {
      return this.tripSummary;
    },
    noTripsFound() {
      return this.trips.length === 0;
    },
    groups() {
      let trips = this.trips.data;
      if (trips == []) {
        return [];
      }
      let bigGroups = [[trips[0]]];
      let i = 0;
      for (let x = 1; x < trips.length; x++) {
        if (bigGroups[i].length >= 3) {
          bigGroups.push([]);
          i += 1;
        }
        bigGroups[i].push(trips[x]);
      }
      return bigGroups;
    },
    booked() {
      return this.$store.state.booked;
    },
    */

    inactiveTrips() {
      return this.tripsLoaded.filter((trip, index) => {
        return trip.tripSummary.status == "inactive";
      });
    },
    cancelledTrips() {
      return this.tripsLoaded.filter((trip, index) => {
        return trip.tripSummary.status == "cancelled";
      });
    },
    activeTrips() {
      return this.tripsLoaded.filter((trip, index) => {
        return trip.tripSummary.status == "active";
      });
    },
    //Contains all trips that have been loaded with their associated trip details
    tripsLoaded() {
      return this.trips.filter((trip, index) => {
        return this.loadStatus[index].loaded === true;
      });
    },
    //Array that contains any trips that are still missing trip details
    tripsNotLoaded() {
      return this.trips.filter((trip, index) => {
        return this.loadStatus[index].loaded !== true;
      });
    },
    //Boolean to track whether details have successfully loaded for all trips
    allDetailsLoaded() {
      return this.trips.length === this.tripsLoaded.length;
    },
  },
  methods: {
    /*
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    proceed() {
      this.$router.push({ path: "/summary" });
    },
    history() {
      this.$router.push({ path: "/trip-history" });
    },
    bookMore(value) {
      this.$router.push({ path: "/search/" + value });
    },
    delTrip(val) {
      let trips = this.trips.data;
      for (let x = 0; x < trips.length; x++) {
        if (val == trips[x]) {
          // this.trips.data = trips.splice(x, 1);
          this.trips.data = [];
        }
        this.trips.data = [];
      }
      this.tripKey += 1;
    },
    */
    //loads a list of trip
    async getTripList() {
      var post = {
        meta: {
          stateful: false,
          sessionKey: null,
          normalizeResponse: true,
        },
        travelerProfileRecordLocator: this.$globals.profile
          .amadeusRecordLocator,
        //travelerProfileRecordLocator: "HN5NYZ",
        //travelerProfileRecordLocator: "ATUX8T",
        onlyActiveTrips: true,
      };

      let list = await this.$app.huddleLabsServerCall(
        "amadeus/trips/get-trips",
        post
      );
      return list.data;
    },
    //loads trip details for any trips whose details have not been previously loaded
    async fetchTripDetails() {
      return await Promise.all(
        this.trips.map(async (trip, index) => {
          if (this.loadStatus[index]?.loaded !== true) {
            this.updateLoadStatus(index, { loaded: false, loading: true });

            var post = {
              meta: {
                stateful: false,
                sessionKey: null,
                normalizeResponse: true,
              },
              recordLocator: trip.recordLocator,
            };

            let result = await this.$app.huddleLabsServerCall(
              "amadeus/trips/show",
              post
            );
            if (result.data) {
              this.$set(this.trips, index, result.data);

              this.updateLoadStatus(index, { loaded: true, loading: false });
            } else {
              this.updateLoadStatus(index, { loaded: false, loading: false });
            }
          }
        })
      );
    },
    /*
    tripMod(value) {
      var details = {
        parent: this,
        component: TripModal,
        props: {
          trip: value,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 400,
        events: {
          delete: (value) => {
            console.log(value);
            this.delTrip(value);
          },
        },
      };

      this.$buefy.modal.open(details);
    },
    */

    initLoadStatus(trips) {
      trips.forEach((trip, index) => {
        this.loadStatus[index] = { loaded: false, loading: false };
      });
    },
    updateLoadStatus(index, obj) {
      this.loadStatus[index] = obj;
    },
  },

  async mounted() {
    //get array of trips for the user
    this.trips = await this.getTripList();
    this.pageLoading = false;

    this.initLoadStatus(this.trips);

    if (this.trips.length > 0) {
      this.detailsLoading = true;

      //fetch the full trip details for each trip
      await this.fetchTripDetails();

      /**
       * If some trip details fail to load during first API request for any reason (e.g. 401 errors),
       * this will attempt to load them in the background a second time.
       * If they fail to load a second time, then a notification will be displayed to the user.
       *
       */

      if (!this.allDetailsLoaded) await this.fetchTripDetails();
    } else {
      this.noTripsFound = true;
    }

    this.detailsLoading = false;

    let pendings = this.$store.state.travellersAndTrips.pendingTrips;
    pendings.forEach(function(element) {
      element.pending = true;
    });
    this.trips = pendings.concat(this.trips);
  },
};
</script>

<style scoped></style>
